import React from "react";
import { ReactController } from "../react_controller";
import { CollaborativeMicrositeEditor } from "@/components/CollaborativeMicrositeEditor";
import { MicrositeChannelControl } from "~/components/CollaborativeMicrositeEditor/MicrositeChannelControl";
import { stringToHslColor } from "~/components/AwarenessUsers/colors";
import PrimerStyleGuard from "~/components/PrimerStyleGuard";

export class CollaborativeMicrositeEditorController extends ReactController {
  connect() {
    const { id, ...props } = this.propsValue;

    if (!this.channelControl) {
      const awarenessUser = {
        name: props.user.name,
        initials: props.user.initials,
        id: Number(props.user.id),
        color: stringToHslColor(props.user.name),
        avatarUrl: props.user.avatarUrl,
      };

      this.channelControl = new MicrositeChannelControl(
        id,
        awarenessUser,
        props.cableUrl
      );
    }

    // The inner PrimerMicrositeEditor wraps itself in GregPrimerTheme, but
    // CollaborativeMicrositeEditor also renders a sibling save-error banner
    // (Flash/Box/Text with sx props) that sits OUTSIDE that wrapper. Without
    // PrimerStyleGuard, the banner's styled-components emissions go via the
    // default speedy mode and Turbo's <head> merge can dedupe the empty
    // style tags — same FOUC mechanism as GR-1598.
    this.root.render(
      <PrimerStyleGuard>
        <CollaborativeMicrositeEditor
          channelControl={this.channelControl}
          apiBaseUrl={props.apiBaseUrl}
          fileUploadUrl={props.fileUploadUrl}
          useRichText={props.useRichText}
          markdownSectionsEnabled={props.markdownSectionsEnabled}
          sponsorshipEnabled={props.sponsorshipEnabled}
          agendaBuilderEnabled={props.agendaBuilderEnabled}
          registrationSite={props.registrationSite}
          mobileAppEnabled={props.mobileAppEnabled}
          scheduledPagesEnabled={props.scheduledPagesEnabled}
          registrationFlowType={props.registrationFlowType}
          registrationDefaults={props.registrationDefaults}
          eventTitle={props.eventTitle}
          startDate={props.startDate}
          endDate={props.endDate}
          registrationOpens={props.registrationOpens}
          registrationCloses={props.registrationCloses}
          venueName={props.venueName}
          venueCity={props.venueCity}
          venueAddress={props.venueAddress}
          staticMapPreviewUrl={props.staticMapPreviewUrl}
          checkpoints={props.checkpoints}
          tracks={props.tracks}
          timezone={props.timezone}
          tieredListTypes={props.tieredListTypes}
          eventLogoUrl={props.eventLogoUrl}
          pinningEnabled={props.pinningEnabled}
          canPinSections={props.canPinSections}
          canEditPinnedSections={props.canEditPinnedSections}
        />
      </PrimerStyleGuard>
    );
  }

  disconnect() {
    this.channelControl?.dispose?.();
  }
}
